import {Box} from '@mui/material';
import React from 'react';

export const NotFound: React.FC = () => {
    return <Box sx={{fontSize: '2rem', textAlign: 'center', p: 4}}>404 not found</Box>;
};
